import api from "@/api";
export default {
  async addUser({ dispatch }, userData) {
    try {
      const response = await api.post(
        `${process.env.VUE_APP_API_BASE_URL || ''}/rfis/users/add-user`,
        userData
      );
      if (!response.ok) {
        dispatch("showSnackbar", "Failed to create user.");
        throw new Error("Failed to add user");
      } else {
        dispatch("showSnackbar", "User created successfully.");
      }


      return response;
    } catch (error) {
      console.error("Error adding user:", error);
      throw error;
    }
  },

  async loginUser({ commit, dispatch }, userData) {
    try {
      const response = await api.post(
        `${process.env.VUE_APP_API_BASE_URL || ''}/rfis/users/login`,
        userData
      );

      if (!response.ok) {
        dispatch("showSnackbar", "Incorrect credentials. Please try again.");
        throw new Error("Login failed");
      } else {
        dispatch("showSnackbar", "Login successful.");
      }

      if (response.ok) {
        commit("setUser", response.user);
      }

      return response;
    } catch (error) {
      console.error("Error logging in:", error);
      throw error;
    }
  },

  async logout({ commit, dispatch }) {
    try {
      await api.post(`${process.env.VUE_APP_API_BASE_URL || ''}/rfis/users/logout`);

      commit("setUser", null);
      commit("setAuthChecking", false);
      dispatch("showSnackbar", "Logout succesful.");
      return { ok: true };
    } catch (error) {
      console.error("Logout failed:", error);
      return { ok: false, error: error.message };
    }
  },

  async checkAuth({ commit }) {
    commit("setAuthChecking", true);
    try {
      const response = await api.get(
        `${process.env.VUE_APP_API_BASE_URL || ''}/rfis/users/check-auth`
      );
      commit("setUser", response.user);
    } catch (error) {
      commit("setUser", null);
      if (error.response?.status === 403) {
        window.location.href = "/login";
      }
      console.error("There's no user:", error);
    } finally {
      commit("setAuthChecking", false);
    }
  },

  async saveColumns({dispatch}, data) {
    try {
      const response = await api.post(
        `${process.env.VUE_APP_API_BASE_URL || ''}/rfis/users/save-columns`,
        data
      );
      if (!response.ok) {
        dispatch("showSnackbar", "Failed to save columns configuration.")
        throw new Error("Failed to save columns configuration");
      } else {
         dispatch("showSnackbar", "Configuration saved succesfully.")
      }

      return response;
    } catch (error) {
      console.error("Error saveColumns:", error);
      throw error;
    }
  },

  async getUserCols(_, data) {
    try {
      const response = await api.get(
        `${process.env.VUE_APP_API_BASE_URL || ''}/rfis/users/get-user-columns`,
        data
      );
      if (response.ok) {
        return response.data;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  },
};
